import { render, staticRenderFns } from "./LeaderboardFirst.vue?vue&type=template&id=2c7de5dc&scoped=true&"
import script from "./LeaderboardFirst.vue?vue&type=script&lang=js&"
export * from "./LeaderboardFirst.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardFirst.vue?vue&type=style&index=0&id=2c7de5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7de5dc",
  null
  
)

export default component.exports